import { Image, Label } from '@cian/ui-kit';

import * as styles from './SuperAgentBadge.css';
import starSvg from './icons/star.svg';

export type TSuperAgentBadgeProps = {
  levelName: string;
};

export const SuperAgentBadge = ({ levelName }: TSuperAgentBadgeProps) => {
  return (
    <div className={styles['wrapper']}>
      <Label
        data-name={'BadgeSuperAgent'}
        icon={<Image src={starSvg} height={16} width={16} />}
        background="control-positive-secondary-default"
        color="icon-positive-default"
      >
        {levelName}
      </Label>
    </div>
  );
};
